import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    dialogContent: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    dialogTitle: {
      fontSize: "24px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    contactInfoContainer: {
      marginBottom: "16px",
    },
    linkOfferButton: {
      marginTop: "16px",
      alignSelf: "flex-end",
    },
    dialogWrapper: {
        maxWidth: "800px",
        width: "100%",
    }
  };
});
